const SpeedIndexAbsoluteValues = {
    E:    70,
    F:    80,
    G:    90,
    J:   100,
    K:   110,
    L:   120,
    M:   130,
    N:   140,
    P:   150,
    Q:   160,
    R:   170,
    S:   180,
    T:   190,
    U:   200,
    H:   210,
    V:   240,
    W:   270,
    Y:   300,
    // VR: '>210',
    // Z:  '>240',
    // ZR: '>240',
};

export { SpeedIndexAbsoluteValues };